import React, {ChangeEvent, forwardRef, TextareaHTMLAttributes} from "react";
import {useAutoSize} from "./useAutoSize";
import {classNames} from "@shared/utils";
import styles from "./TextArea.module.scss";

type TTextAreaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
    maxRows?: number;
    value: string;
};

export const TextArea = forwardRef<HTMLTextAreaElement, TTextAreaProps>(
    ({onChange, rows = 1, maxRows, value, ...props}, ref) => {

        // const valueAsString = value === null ? "" : String(value);
        const {isOverflowAuto, textAreaHeight, textAreaRef} = useAutoSize(maxRows, value);

        const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
            if (onChange) {
                onChange(e);
            }
        };

        return (
            <textarea
                className={classNames(styles.root)}
                {...props}
                ref={textAreaRef}
                value={value}
                onChange={handleChange}
                rows={rows}
                style={{
                    overflow: isOverflowAuto ? 'auto' : 'hidden',
                    height: textAreaHeight
                }}
                dir="auto"
            />
        )
    })